import { Component, OnInit } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { VendorTerm, SalesRep } from 'app/core/model/entity-model';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-vendor-term-dialog',
    templateUrl: './vendor-term-dialog.component.html',
    styleUrls: ['./vendor-term-dialog.component.scss'],
    standalone: false
})
export class VendorTermDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    vendorTerm: VendorTerm;
    displayOrder: number;
    validationGroup: 'vendorTermValidationGroup';
    baseTypes = ['Percentage Based', 'Amount Based'];

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        if (!this.vendorTerm) {
            this.vendorTerm = this.uow.vendorTerms.createEntity({
                displayOrder: this.displayOrder,
            }) as VendorTerm;
        }
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('vendorTermValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('vendorTermValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
